<div class="d-flex justify-content-between align-center">
  <div>
    <strong>
      <span>Copyright &copy; {{ currentYear }}</span>
      <a
        href="https://www.alphastarav.com/"
        target="_blank"
        rel="noopener noreferrer"
        class="m-0">
        alphastarav.com</a
      >
      <span>.</span>
    </strong>
    <span> All rights reserved.</span>

    <span class="ml-2 mr-2">
      <a
        style="text-decoration: underline"
        href="{{ constants.PRIVACY_POLICY_URL }}"
        target="_blank"
        rel="noopener noreferrer"
        class="m-0">
        Privacy policy
      </a>
    </span>
  </div>

  <div class="float-right d-none d-sm-block">
    <b>Version: </b>{{ currentAppVersion }}
  </div>
</div>
